import { useMemo } from "react";
import { useAccessToken } from "shared-ts-utils-authentication";
import { MunicipalityDao } from "./MunicipalityDao";
import {
  CustomerEnvironmentName,
  useCustomerEnvironmentName,
} from "firefly-shared-ts-customer-environment";
import { _throw, NullError } from "shared-ts-utils-core";

export const useMunicipalityDao = (
  defaultCustomerEnvironmentName?: CustomerEnvironmentName
): MunicipalityDao => {
  const accessToken = useAccessToken();
  const customerEnvironmentName =
    useCustomerEnvironmentName() ?? defaultCustomerEnvironmentName;
  return useMemo(
    () =>
      new MunicipalityDao({
        accessToken: accessToken,
        customerEnvironment:
          customerEnvironmentName ??
          _throw(new NullError("customerEnvironmentName")),
      }),
    [accessToken, customerEnvironmentName]
  );
};
